export default __webpack_public_path__ + "static/media/blockbreaker.f0a6c242.png";